var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container d-none d-md-block"},[_c('div',{staticClass:" p-3 d-flex justify-content-end align-items-center"},[_c('Search',{staticClass:"mr-3"}),_c('Cart')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }